import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Form, Input, FormGroup, Label, Button } from 'reactstrap';
//import { CommonApiFetch }  from '../tools/utils';

class FY_Manager extends Component {
    static displayName = FY_Manager.name;

    constructor(props) {
        super(props)

        this.state = {
            permissionFlag: true,
            userInfo: this.props.reduxData.userInfo,
            tableData: [],
            formName: "",
            formYearOptions: [],
            formYearSelection: "DEFAULT",
            updateTextKey: 1
        }
        this.apiFetch('ValidDepartments', { pagepk: "/FYManage" },"permissionFlag")
    }

    async apiFetch(url, body, stateItem) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            ...body
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.props.reduxData.apiKey },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        this.setState({
            [stateItem]: data
        }, () => {
            if (stateItem == "permissionFlag" && data == true) {
                this.apiFetch("FYManageGetTable", {}, "tableData")
            }
            if (stateItem == "tableData" && data.length > 0 && url != "FYManageUpdateVal") {
                const generateArray = (aroundNumber) => [...Array(9).keys()].map(i => i + aroundNumber - 3);
                let yearList = data.map(option => option.year)
                let yearOp = generateArray(new Date().getFullYear() + 2).filter((yr) => !yearList.some(item => item == yr))
                this.setState({
                    formYearOptions: yearOp,
                    formYearSelection: "DEFAULT",
                    formName: ""
                })
            }
            if (url == "FYManageUpdateVal") {
                this.setState({
                    updateTextKey: this.state.updateTextKey + 1
                })
            }
        })
    }

    addValue(e) {
        e.preventDefault();
        this.apiFetch("FYManageAddRecord", { year: this.state.formYearSelection, txt: this.state.formName }, "tableData")
    }

    updateValue(pk, txt) {
        this.apiFetch('FYManageUpdateVal', { pk: pk, val: txt }, "tableData")

        //let newData = useCommonApiFetch('FYManageUpdateVal', { pk: pk, val: txt })
        //console.log("newData: " , newData)
        //this.setState({
        //    tableData: newData
        //})

        //CommonApiFetch('FYManageUpdateVal', { pk: pk, val: txt })
        //    .then((response) => console.log(response));

    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        return (<div>
            {this.state.tableData.length > 0 && <Form className="d-flex" onSubmit={(e) => this.addValue(e) }>
                <FormGroup>
                    <Label>Year</Label>
                    <Input type="select" name="eventYear" id="eventYear" value={this.state.formYearSelection} onChange={(e) => this.setState({ formYearSelection: e.target.value })}>
                        <option value="DEFAULT" disabled>Select...</option>
                        {this.state.formYearOptions.map(item => (
                            <option>{item}</option>
                        ))}
                    </Input>
                </FormGroup>
                &ensp;
                <FormGroup>
                    <Label>Name</Label>
                    <Input type="text" name="eventTitle" id="eventTitle" value={this.state.formName} onChange={(e) => this.setState({ formName: e.target.value })} />
                </FormGroup>
                &ensp;
                <Button outline color="success" onClick={(e) => this.addValue(e) }>Add</Button>
            </Form>}
            <br />
            {this.state.tableData.length > 0 && <Table>
                <thead>
                    <tr>
                        <th>Year</th>
                        <th>Event Name Starts With...</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.tableData.map(item => (
                        <tr>
                            <td>{item.year}</td>
                            <td><div><Input key={this.state.updateTextKey} type="text" name={"nameBox" + item.pk} id={"nameBox" + item.pk} defaultValue={item.name} onBlur={(e) => this.updateValue(item.pk, e.target.value)} />
                                {item.year > (new Date().getFullYear() + 2) && <Button color="danger" onClick={() => this.apiFetch("FYManageDelete", { pk: item.pk }, "tableData")}>Delete</Button>}
                            </div>
                            </td>
                        </tr>
                    )) }
                </tbody>
            </Table>}
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(FY_Manager);